import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

type PrivateRouteProps = {
    children: React.ReactNode;
    path: string;
    exact: boolean;
};

const PrivateRoute = ({ children, path, exact }: PrivateRouteProps) => {
    const auth = useAuth();

    return (
        <Route
            path={path}
            exact={exact}
            render={({ location }) => {
                if (auth.isLoading) {
                    return <div>Loading...</div>;
                }

                if (auth.isAuthenticated) {
                    return children;
                }

                return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
            }}
        />
    );
};

export default PrivateRoute;
